import React from "react";
import { Link } from "react-router-dom";
const HomeBanner = () => {
  return (
    <div className="w-full h-auto flex items-center xs:pt-[200px] pt-52 md:pt-40 xl:pt-64 3xl:pt-[21rem] justify-center text-white relative">
      <div className="w-[85%] md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[90rem] mx-auto ">
        {/* Content */}
        <div
          className="z-10 pt-16 md:w-4/5 flex flex-col justify-start tracking-wide"
          data-aos="fade-up"
        >
          <h1
            className="text-[32px] md:block hidden md:text-[42px] xl:text-[70px] 3xl:text-[76px] font-extralight font-lexend leading-tight mb-4"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            CHANGE THE WORLD <br /> IN YOUR SLEEP
          </h1>
          <h1
            className="text-[34px] md:hidden block  font-extralight font-lexend leading-tight mb-4"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            CHANGE <br/> THE WORLD <br /> IN YOUR SLEEP
          </h1>

          <p
            className="mb-6 font-lexend font-light xs:text-[15px] text-[18px] xs:w-[85%] w-[80%] lg:w-[70%] xl:w-[50%] 2xl:w-[38%]"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Choose a mattress that’s good for you, for the community, and for
            the planet.
          </p>
          <Link
            to="/about"
            className="relative sm:px-2 px-6 sm:py-1.5 py-3 sm:w-32 sm:text-[15px] w-48 text-[22px] tracking-wider font-normal font-lexend  bg-transparent isolation-auto z-10 border-2 border-[#f4e391] before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full hover:text-[#38693e] before:-left-full before:hover:left-0 before:rounded-full before:bg-[#f4e391] before:-z-10 before:aspect-square before:hover:scale-150 overflow-hidden before:hover:duration-700 inline-flex items-center justify-center text-[#f4e391] shadow-sm gap-x-2 disabled:opacity-50 disabled:pointer-events-none hover:font-normal sm:hover:text-[15px] hover:text-[22px]"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            OUR STORY
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HomeBanner;
